import { PanelDesignTokens } from '@primeuix/themes/types/panel'

const index: PanelDesignTokens = {
  title: {
    fontWeight: '500'
  }
}

const pt = {
  title: 'h4'
}

export { index as default, pt }
